import { getCookie } from '../utils/cookie';

import request, { apiURL, patch, get } from '../utils/api';
type Modification = {
  checklistItemId: string,
  checklistItemOptionId: string,
  applicantChecklistDecisionId: string,
}[];

class ApplicantChecklistService {
  updateChecklistItem(
    propertyId: string,
    organizationId: string,
    modification: Object,
  ) {
    const options = {
      method: 'PUT',
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        checklistItemId: modification.checklistItemId,
        checklistItemOptionId: modification.checklistItemOptionId,
        applicantChecklistDecisionId: modification.applicantChecklistDecisionId,
      }),
    };
    return request(
      `${apiURL}/${organizationId}/${propertyId}/applicantChecklist/${modification.applicantChecklistId}`,
      options,
    );
  }
  updateMultipleChecklistItems(
    propertyId: string,
    organizationId: string,
    applicantChecklistId,
    modification: Modification[],
  ) {
    const body = JSON.stringify(modification);

    return patch(
      `/${organizationId}/${propertyId}/applicantChecklist/${applicantChecklistId}`,
      body,
    );
  }

  getChecklistByApplicantId({ propertyId, organizationId, applicantId }) {
    return get(
      `/${organizationId}/${propertyId}/applicant/${applicantId}/applicantChecklist`,
    );
  }
}

export default ApplicantChecklistService;
